export default __webpack_public_path__ + "static/media/watch.497f635f.jpg";